import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=0f7180fd&scoped=true&"
import script from "./modal.js?vue&type=script&lang=js&"
export * from "./modal.js?vue&type=script&lang=js&"
import style0 from "./modal.scss?vue&type=style&index=0&id=0f7180fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7180fd",
  null
  
)

export default component.exports